import React from "react";
import { useTranslation } from "react-i18next";

const FILTER_TABS = [
  { key: "all", labelKey: "globalSearch.filterAll" },
  { key: "festival", labelKey: "globalSearch.filterFestivals" },
  { key: "journey", labelKey: "globalSearch.filterJourneys" },
] as const;

interface FilterTabsProps {
  active: string;
  onChange: (key: string) => void;
}

export const FilterTabs = React.memo(function FilterTabs({ active, onChange }: FilterTabsProps) {
  const { t } = useTranslation();
  return (
    <div className="flex gap-1 px-4 py-2 overflow-x-auto scrollbar-none border-b">
      {FILTER_TABS.map((tab) => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          className={`shrink-0 px-3 py-1.5 text-xs font-medium rounded-full transition-colors ${
            active === tab.key
              ? "bg-primary text-primary-foreground"
              : "bg-muted text-muted-foreground hover:bg-accent"
          }`}
        >
          {t(tab.labelKey, tab.key === "all" ? "All" : tab.key)}
        </button>
      ))}
    </div>
  );
});
